import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSwitchComponent } from './input-switch.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [InputSwitchComponent],
  imports: [CommonModule, InputSwitchModule, FormsModule],
  exports: [InputSwitchComponent],
})
export class InputSwitchComponentModule {}
